import { FC, useContext } from 'react'
import { endSession } from "../../../../hooks/common"
import "./HeaderUserMenu.css";
import Cookies from "universal-cookie";

const HeaderUserMenu: FC = () => {
    const logout = () => {
        endSession()
    }

    const cookies = new Cookies();
    const showProfile = !(cookies.get('sso_enabled') === 'true')

    return (
        <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-250px'
            data-kt-menu='true'
        >
            {showProfile && (
                <div className='menu-item px-5'>
                    <a href='/profile.html' className='menu-link px-5 d-flex align-items-center'>
                        <i className="bi bi-person-fill fs-1 me-3" aria-hidden="true"></i>
                        <span>My Profile</span>
                    </a>
                </div>
            )}

            <div className='menu-item px-5'>
                <button
                    onClick={logout}
                    className='menu-link px-5 d-flex align-items-center border-0 bg-transparent w-100 text-start'
                    type="button"
                >
                    <i className="bi bi-box-arrow-right fs-1 me-3" aria-hidden="true"></i>
                    <span>Sign Out</span>
                </button>
            </div>
        </div>
    )
}

export { HeaderUserMenu }